import React, { useEffect, useState } from 'react';
import style from './chart.module.scss';
import ReactEcharts from 'echarts-for-react';
import options from './chartAll.jsx';
import NoData from './noData.jsx';
import EventBus from '@/modules/pain-points/hooks/eventBus';
import ClickDot from './clickDot.jsx';


const chartDetail = () => {
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  let [data, setData] = useState({
    id: 0,
    pies: [0.9,1.2,1,23,33],
    needState: [{response: 'Easy everyday cooking', count: 592},{response: 'Easy everyday cooking', count: 392}],
    generation: [{response: 'Baby Boomers', count: 233},{response: 'Baby Boomers', count: 333},{response: 'Baby Boomers', count: 133},{response: 'Baby Boomers', count: 533}],
    lifestage: [{response: 'Pre-Family', count: 242},{response: 'Pre-Family', count: 142},{response: 'Pre-Family', count: 342},{response: 'Pre-Family', count: 142},{response: 'Pre-Family', count: 242},{response: 'Pre-Family', count: 342}],
    frequencyOfConsumption: [{response: 'Once a month ', count: 270},{response: 'Once a month ', count: 370},{response: 'Once a month ', count: 470},{response: 'Once a month ', count: 370},{response: 'Once a month ', count: 270},{response: 'Once a month ', count: 170}],
    contemporaryCooks: [{response: 'Traditional Cook', count: 350},{response: 'Modern Cook', count: 550}],
  });

  useEffect(() => {
    //挂载
    EventBus.addEventListener('painPointDetailEvent', handlePainPointDetailEvent);
    return (() => {
      //卸载
      EventBus.removeEventListener('painPointDetailEvent', handlePainPointDetailEvent);
    });
  }, [data]);
  useEffect(() => {
    EventBus.addEventListener('isDetailLoading', handleIsDetailLoading);
    return (() => {
      EventBus.removeEventListener('isDetailLoading', handleIsDetailLoading);
    });
  }, []);
  const handleIsDetailLoading = (e) => {
    setIsDetailLoading(e.detail);
  };  
  const handlePainPointDetailEvent = e => {
    console.log('dataD接收到传值啦！~~~~~~');
    if(Object.keys(e.detail).length != 0){
      const dataD = numberToPercent(e.detail)
      dataD.pies[4] = (Math.round(dataD.pies[2] / dataD.pies[3] * 10000) / 100.00).toFixed(1);
      setData(dataD);
    }else{
      setData({
        id: 0,
        pies: [0.9,1.2,1,23,33],
        needState: [{response: 'Easy everyday cooking', count: 592},{response: 'Easy everyday cooking', count: 392}],
        generation: [{response: 'Baby Boomers', count: 233},{response: 'Baby Boomers', count: 333},{response: 'Baby Boomers', count: 133},{response: 'Baby Boomers', count: 533}],
        lifestage: [{response: 'Pre-Family', count: 242},{response: 'Pre-Family', count: 142},{response: 'Pre-Family', count: 342},{response: 'Pre-Family', count: 142},{response: 'Pre-Family', count: 242},{response: 'Pre-Family', count: 342}],
        frequencyOfConsumption: [{response: 'Once a month ', count: 270},{response: 'Once a month ', count: 370},{response: 'Once a month ', count: 470},{response: 'Once a month ', count: 370},{response: 'Once a month ', count: 270},{response: 'Once a month ', count: 170}],
        contemporaryCooks: [{response: 'Traditional Cook', count: 350},{response: 'Modern Cook', count: 550}],
      });
    }
  };

  const getPieColor = (v) => {
    return '#E1FF75'
    if (v < 5) return '#d90000';
    if (v < 30) return '#fdba38';
    return '#00a22e';
  };

  const renameLifeStage = (value) => {
    value.map(i => {
      i.response = getLifeStageText(i.response);
    })
    return value
  } 
  const getLifeStageText = (value) => {
    switch(value){
      case 'Pre-Family: Single +': return 'Pre-Family';
      case 'Pre-Family: Marriage without kids ': return 'Marriage w/o kids';
      case 'Young Family 0-4 years': return 'Young Family 0-4yrs';
      case 'Middle Family 5-12 years': return 'Middle Family 5-12yrs';
      case 'Family 13-17 years': return 'Family 13-17yrs';
      case 'Family 18+ years': return 'Family 18+ yrs';
      case 'Empty Nesters': return 'Empty Nesters';
      default: return value;
    }
  }
  const sortNeedStateList = ['Easy everyday cooking', 'An enjoyment meal'];
  const sortGenerationList = ['Gen Z', 'Millennials', 'Gen X ', 'Baby Boomers'];
  const sortLifeStageList = ['Pre-Family', 'Marriage w/o kids', 'Young Family 0-4yrs', 'Middle Family 5-12yrs', 'Family 13-17yrs', 'Family 18+ yrs', 'Empty Nesters'];
  const sortFrequencyOfConsumptionList = ['Multiple times a week ', 'Once a week ', 'Once every two weeks ', 'Once a month ', 'Once every two months ', 'Once every three months ', 'Less often than every three months '];
  const sortContemporaryCooksList = ['Contemporary Cook', 'Traditional Cook'];

  const sortData = (data,sortList) => {

    const sortDataList = data.sort(function(a, b) {
      return sortList.indexOf(a.response) - sortList.indexOf(b.response);
      // return b.percent - a.percent
    });
    return sortDataList;
  }

  const numberToPercent = (calculateData) => {
    calculateData = numberItemToPercent('contemporaryCooks', calculateData)
    calculateData = numberItemToPercent('frequencyOfConsumption', calculateData)
    calculateData = numberItemToPercent('generation', calculateData)
    calculateData = numberItemToPercent('lifestage', calculateData)
    calculateData = numberItemToPercent('needState', calculateData)
    return calculateData
  }

  const numberItemToPercent = (itemtitle,calculateData) => {
    calculateData[itemtitle].forEach(item => {
      item.percent = (item.count / calculateData.needStatementMatching_total*100).toFixed(1);
    });
    return calculateData
  }


  return <>
        <div className={style.chartDetailContent}>
        {isDetailLoading && (
          <div className={style.detailLoadingOverlay}>
            <div className={style.spinner}></div>
            <div className={style.loadingText}>Loading...</div>
          </div>
        )}
        {data.id === 0 && (
          <div className={style.clickDotOverlay}>
            <ClickDot/>
          </div>
        )}
          <div className={style.chartDetailTop}>

            <div className={style.chartDetailTopLeft}>

              <div className={style.chartDetailTopLeftTitleBox}>
                <div style={{ color: getPieColor(data.pies[2]) }} title='Indicates the % of respondents who identify with this need'>Reach</div>
                <ReactEcharts style={{ height: '168px', width: '100%', paddingBottom: '15px' }}
                              option={options.optionC([{ value: data.pies[4] }], getPieColor(data.pies[4]),0)} />
              </div>

              <div className={style.chartDetailTopLeftTitleBox}>
                <div style={{ color: getPieColor(data.pies[1]) }} title='Indicates the average % importance that respondents assign to this need'>Importance</div>
                <ReactEcharts style={{ height: '168px', width: '100%', paddingBottom: '15px' }}
                              option={options.optionC([{ value: Number(data.pies[1]).toFixed(1)}], getPieColor(data.pies[1]),1)} />
              </div>

              <div className={style.chartDetailTopLeftTitleBox}>
                <div style={{ color: getPieColor(data.pies[0]) }} title='Indicates the average % extra amount respondents are willing to pay to fullfil this need' className={style.chartDetailDoubleRowTitle}>
                  <span>Willingness</span>
                  <span>to pay</span>
                </div>

                <ReactEcharts style={{ height: '168px', width: '100%', paddingBottom: '15px' }}
                              option={options.optionC([{ value: Number(data.pies[0]).toFixed(1)}], getPieColor(data.pies[0]),2)} />
              </div>
            </div>


            <div className={style.chartDetailTopLeftTitleBox} style={{ width: '20%' }}>
              <div style={{ color: '#67aad9' }}>Occasions</div>
              <ReactEcharts style={{ height: '170px', width: '100%' }}
                            option={options.optionD(sortData(data.needState, sortNeedStateList) || [], [103, 170, 217])} />
            </div>

            <div className={style.chartDetailTopLeftTitleBox} style={{ width: '30%' }}>
              <div style={{ color: 'rgba(125,192,165)' }}>Generation</div>
              <ReactEcharts style={{ height: '170px', width: '100%' }}
                            option={options.optionD(sortData(data.generation, sortGenerationList) || [], [125, 192, 165])} />
            </div>

          </div>
          <div className={style.chartDetailTop}>

            <div className={style.chartDetailTopLeftTitleBox} style={{ width: '41%' }}>
              <div style={{ color: 'rgba(196,87,103)' }}>Lifestage</div>
              <ReactEcharts style={{ height: '170px', width: '100%' }}
                            option={options.optionD(sortData(renameLifeStage(data.lifestage), sortLifeStageList) || [], [196, 87, 103])} />
            </div>

            <div className={style.chartDetailTopLeftTitleBox} style={{ width: '38%' }}>
              <div style={{ color: 'rgb(72,159,64)' }}>Frequency of Consumption</div>
              <ReactEcharts style={{ height: '170px', width: '100%' }}
                            option={options.optionD(sortData(data.frequencyOfConsumption, sortFrequencyOfConsumptionList) || [], [72, 159, 64])} />
            </div>

            <div className={style.chartDetailTopLeftTitleBox} style={{ width: '15%' }}>
              <div style={{ color: 'rgb(253,186,56)' }}>Contemporary Cooks</div>
              <ReactEcharts style={{ height: '170px', width: '100%' }}
                            option={options.optionD(sortData(data.contemporaryCooks, sortContemporaryCooksList) || [], [253, 186, 56])} />
            </div>

          </div>
        </div>
  </>;

};


export default chartDetail;